import ImagesFooterSocialsDarkFacebookSvg from '@/public/images/footer/socials-dark/facebook.svg';
import ImagesFooterSocialsDarkInstagramSvg from '@/public/images/footer/socials-dark/instagram.svg';
import ImagesFooterSocialsDarkTikTokSvg from '@/public/images/footer/socials-dark/tik-tok.svg';
import ImagesFooterSocialsDarkYoutubeSvg from '@/public/images/footer/socials-dark/youtube.svg';

export {
  ImagesFooterSocialsDarkFacebookSvg,
  ImagesFooterSocialsDarkInstagramSvg,
  ImagesFooterSocialsDarkTikTokSvg,
  ImagesFooterSocialsDarkYoutubeSvg,
};
